import Falcon from './falcon';
import Stellarus from './stellarus';
import Serenith from './serenith';
import Narukami from './narukami';
import Welkin from './welkin';
import Inferno from './inferno';
import Tricera from './tricera';
import Luminae from './luminae';
import Panther from './panther';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();

export const MECHA_INFO = [
  {
    id: 'panther',
    name: '黑豹特装机',
    component: Panther,
    btnRectInfo: {
      btnW: 265,
      btnH: 73,
      btnXOffset: -800,
      btnYOffset: 330
    }
  },
  {
    id: 'luminae',
    name: '卢米纳尔特装机',
    component: Luminae,
    btnRectInfo: {
      btnW: 245,
      btnH: 77,
      btnXOffset: -532,
      btnYOffset: 390
    }
  },
  {
    id: 'inferno',
    name: '地狱火特装机',
    component: Inferno,
    btnRectInfo: {
      btnW: 283,
      btnH: 84,
      btnXOffset: -970,
      btnYOffset: 114
    }
  },
  {
    id: 'tricera',
    name: '三角龙特装机',
    component: Tricera,
    btnRectInfo: {
      btnW: 253,
      btnH: 84,
      btnXOffset: 770,
      btnYOffset: 222
    }
  },
  {
    id: 'welkin',
    name: '赤霄特装机',
    component: Welkin,
    btnRectInfo: {
      btnW: 306,
      btnH: 80,
      btnXOffset: 520,
      btnYOffset: 164
    }
  },
  {
    id: 'narukami',
    name: '鸣神特装机',
    component: Narukami,
    btnRectInfo: {
      btnW: 218,
      btnH: 73,
      btnXOffset: 680,
      btnYOffset: 114
    }
  },
  {
    id: 'serenith',
    name: '白虹特装机',
    component: Serenith,
    btnRectInfo: {
      btnW: 258,
      btnH: 73,
      btnXOffset: -330,
      btnYOffset: 268
    }
  },
  {
    id: 'stellarus',
    name: '飞景特装机',
    component: Stellarus,
    btnRectInfo: {
      btnW:
        {
          de: 315,
          ru: 275
        }[lang] || 251,
      btnH:
        {
          de: 62,
          th: 68
        }[lang] || 64,
      btnXOffset: -776,
      btnYOffset: 214
    }
  },
  {
    id: 'falcon',
    name: '矛隼特装机',
    component: Falcon,
    btnRectInfo: {
      btnW: 500,
      btnH: 150,
      btnXOffset: 516,
      btnYOffset: 114
    }
  }
];
